






















import { Component, Vue } from 'vue-property-decorator'
import loadingGif from '@/assets/img/loading.gif'
import store from '@/store'
import { Button, Card } from '@alpha/ink'

@Component({
  components: { Card, Button }
})
export default class Reports extends Vue {
  loading:boolean = true
  loadingGif = loadingGif
  reports:any = []

  createSharedReports () {
    const routeData = this.$router.resolve({ path: `/${this.$router.currentRoute.params.workspaceId}/${this.$router.currentRoute.params.testId}/SharePreview/` })
    window.open(routeData.href, '_blank')
  }

  reportLink (reference:string):string {
    return `/report/${reference}`
  }

  mounted () {
    let gatheredReports:any = []
    if (store.getters.workspace.sharedReportsTests[this.$router.currentRoute.params.testId]) {
      gatheredReports = gatheredReports.concat(store.getters.workspace.sharedReportsTests[this.$router.currentRoute.params.testId])
    }
    this.reports = gatheredReports
    this.loading = false
  }
}
